import React, { useState } from 'react';
import Quiz from './Quiz';
import Scoreboard from './Scoreboard';
import SetupScreen from './SetupScreen';
import './App.css';

const App = () => {
  const initialTeams = [
    { name: 'Team 1', score: 0, kidName: 'Vihaan Pendyala', grade: '6', subject: 'maths', topic: 'division' },
    { name: 'Team 2', score: 0, kidName: 'Krithi Pendyala', grade: '3', subject: 'maths', topic: 'division' }
  ];

  const [teams, setTeams] = useState(initialTeams);
  const [currentRound, setCurrentRound] = useState(1);
  const [currentTeam, setCurrentTeam] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [totalRounds, setTotalRounds] = useState(null); // Initially null to show setup screen

  const handleAnswer = (isCorrect) => {
    if (currentRound >= totalRounds) {
      setGameOver(true);
      return;
    }

    setTeams(prevTeams => {
      const updatedTeams = [...prevTeams];
      if (isCorrect) {
        updatedTeams[currentTeam].score += 1;
      }
      return updatedTeams;
    });
    setCurrentTeam((prevTeam) => (prevTeam + 1) % teams.length);
    setCurrentRound((prevRound) => prevRound + 1);
  };
  const restartGame = () => {
    fetch('http://10.249.97.146:5000/api/clear_history', { method: 'POST' })
      .then(response => response.json())
      .then(() => {
        setTeams(initialTeams);
        setCurrentRound(1);
        setCurrentTeam(0);
        setGameOver(false);
        setTotalRounds(null); // Reset to show setup screen
      });
  };

  const startGame = (rounds, teams) => {
    setTotalRounds(rounds);
    setTeams(teams);
  };

  return (
    <div className="app">
      {totalRounds === null ? (
        <SetupScreen onStart={startGame} initialTeams={initialTeams} />
      ) : gameOver ? (
        <div className="game-over">
          <h1>Game Over</h1>
          <Scoreboard teams={teams} currentRound={currentRound} currentTeam={currentTeam} totalRounds={totalRounds} />
          <button onClick={restartGame} className="restart-button">Restart Game</button>
        </div>
      ) : (
        <>
          <Scoreboard teams={teams} currentRound={currentRound} currentTeam={currentTeam} totalRounds={totalRounds} />
          <Quiz onAnswer={handleAnswer} team={teams[currentTeam]} />
        </>
      )}
    </div>
  );
};

export default App;